import { useLocale } from '@ecomm/data-hooks'
import { useMemo } from 'react'
import { match } from 'ts-pattern'

import { Breadcrumbs as BreadcrumbsComponent } from './Breadcrumbs'

import type { FeatureFlag } from '@ecomm/shared-ninetailed'
import { safeMapExperiences } from '@ecomm/shared-ninetailed'
import { Experience } from '@ecomm/shared-ninetailed-experience'
import { usePhoneExperienceProps } from '../../experiments/usePhoneExperienceProps'
import { FullHeader } from './FullHeader'
import { SlimHeader } from './SlimHeader'
import type { HeaderProps } from './types'

function Header({
  type = 'full',
  slimMenuText = '',
  slimMenuURL = '',
  images,
  quoteWizard
}: HeaderProps) {
  const experimentData = usePhoneExperienceProps()
  const locale = useLocale()
  const experiences = useMemo(
    () =>
      safeMapExperiences<FeatureFlag['data']>({
        nt_experiences: experimentData.nt_experiences
      }),
    [experimentData]
  )

  return (
    <>
      {match(type)
        .with('slim', 'plain', 'plain-with-no-link', () => (
          <SlimHeader
            {...{ type, slimMenuText, slimMenuURL, images, quoteWizard }}
          />
        ))
        .with('full', () =>
          locale === 'en-US' ? (
            <Experience
              component={FullHeader}
              experiences={experiences}
              id={experimentData.id}
              loadingComponent={() => (
                <FullHeader {...{ images, quoteWizard }} />
              )}
              passthroughProps={{
                images,
                quoteWizard
              }}
            />
          ) : (
            <FullHeader {...{ images, quoteWizard }} />
          )
        )
        .exhaustive()}
    </>
  )
}

// The `Breadcrumbs` component is being exported here to use it below the `Header` without
// caring about the Optimizely experiment. Once the experiment is finished, we'll add it to this component.
const Breadcrumbs = BreadcrumbsComponent

export { Header, Breadcrumbs }
